import type { PriceFilterTags } from '@/components/features';
import { IMAGE_URL_REPLACEMENT } from '@/constants/imageUrlReplacement';
import { PRICE_FILTER_MAX } from '@/constants/priceFilterRanges';

export const toTitleCase = (str: string): string => {
  if (!str) return '';
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatIndianPrice = (price: string | number): string => {
  if (price == null || price === '') return '';

  const num = Number(price.toString().replace(/[^\d.]/g, ''));
  if (isNaN(num)) return '';

  const hasDecimal = num % 1 !== 0;

  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  }).format(num);
};

export const cleanProductName = (
  productName: string,
  brand: string
): string => {
  if (!brand || !productName) return productName;
  const regex = new RegExp(brand, 'gi');
  return productName.replace(regex, '').trim();
};

export const updatedImageUrl = (url: string): string => {
  if (!url) return '';

  const matchingQuery = IMAGE_URL_REPLACEMENT.from.find((from) =>
    url.includes(from)
  );

  if (matchingQuery) {
    return url.replace(matchingQuery, IMAGE_URL_REPLACEMENT.to);
  }
  return url;
};

export const decodeBase64Url = (input: string): string => {
  const normalized = input.replace(/-/g, '+').replace(/_/g, '/');
  const padding =
    normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
  return atob(normalized + padding);
};

export const getMinMaxPriceRange = (
  priceFilters: PriceFilterTags[]
): { minPrice: number; maxPrice: number } => {
  let minVal = Infinity,
    maxVal: number = 0;

  priceFilters.forEach((range) => {
    if (range.isSelected) {
      if (range.min < minVal) minVal = range.min;
      if (range.max > maxVal) maxVal = range.max;
    }
  });

  if (minVal === Infinity) return { minPrice: 0, maxPrice: PRICE_FILTER_MAX };

  return { minPrice: minVal, maxPrice: maxVal };
};
